function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M0 12h10v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M.5 12.5h9v6h-9z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M11 4h3v10h-3z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M11.5 4.5h2v9h-2z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M28.75 22H21.4a5.5 5.5 0 00-5.4-2.978V12.01c.166-.007.333-.01.5-.01 6.047 0 11.092 4.294 12.25 10z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M28.122 21.5a12.006 12.006 0 00-11.622-9v6a5.998 5.998 0 015.197 3h6.425z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M10 7h5v6h-5z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M10.5 7.5h4v5h-4z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M26.5 31c1.667-.796 2.5-1.685 2.5-2.667 0-.982-.833-2.76-2.5-5.333-1.667 2.574-2.5 4.351-2.5 5.333 0 .982.833 1.871 2.5 2.667z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M26.5 30.443c1.363-.69 2-1.403 2-2.11 0-.773-.666-2.264-2-4.401-1.334 2.137-2 3.628-2 4.401 0 .707.637 1.42 2 2.11z"
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 9,
  height: 4,
  x: 21,
  y: 21,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  width: 8,
  height: 3,
  x: 21.5,
  y: 21.5,
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M8.434 1.064l1.124.931h5.774l1.223-.987a2.783 2.783 0 014.532 2.165v.032a3 3 0 01-4.732 2.45l-1.023-.723H9.558l-.894.648a2.972 2.972 0 01-4.716-2.407 2.739 2.739 0 014.486-2.109z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M8.115 1.45a2.239 2.239 0 00-3.667 1.723 2.472 2.472 0 003.923 2.002l1.025-.743h6.095l1.153.815a2.5 2.5 0 003.943-2.042v-.032a2.283 2.283 0 00-3.718-1.776l-1.36 1.098h-6.13L8.114 1.45z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M8 11h9v9H8z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  "data-svg-class": "RoomButton-stroke",
  d: "M8.5 11.5h8v8h-8z"
}));

function SvgRoomSpigot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSpigot);
export default __webpack_public_path__ + "static/media/RoomSpigot.797228b8.svg";
export { ForwardRef as ReactComponent };